import * as XLSX from "xlsx-js-style";

export const exportDataToCsv = (
	gridRef: any,
	selectedColumnIds: string[],
	data?: any[]
) => {
	const selectedRows = gridRef.current?.api?.getSelectedRows();
	const onlySelected = selectedRows && selectedRows.length > 0;

	const date = new Date();
	const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
		date.getMonth() + 1
	)
		.toString()
		.padStart(2, "0")}-${date.getFullYear()}`;

	const randomNumber = Math.floor(Math.random() * 1000)
		.toString()
		.padStart(3, "0");

	const fileName = `${formattedDate}_${randomNumber}.xlsx`;

	let dataToExport = [];
	if (!data) {
		gridRef.current?.api.forEachNode((node: any) =>
			dataToExport.push(node.data)
		);
	} else {
		dataToExport = data;
	}

	// Get the data from the grid
	const rowData = onlySelected ? selectedRows : data;

	// Create a new workbook
	const wb = XLSX.utils.book_new();

	// Extract the headers based on selectedColumnIds
	const headers = selectedColumnIds.map((colId) => ({
		[colId]: gridRef.current?.api?.getColumnDef(colId)?.headerName || colId,
	}));

	// Create a styled header row
	const headerRow = headers.map((header) => {
		const headerKey = Object.keys(header)[0];
		return {
			t: "s",
			v: header[headerKey],
			s: {
				font: {
					name: "Calibri",
					sz: 12,
					bold: true,
					color: { rgb: "FFFFFF" },
				},
				fill: {
					fgColor: { rgb: "6d31a2" }, // Background color #4f16c2
				},
				alignment: {
					vertical: "center",
					horizontal: "start",
				},
			},
		};
	});

	// Map row data to selected column keys
	const sheetData = rowData.map((row: any) =>
		selectedColumnIds.map((colId) => row[colId] || "")
	);

	// Combine header and data rows
	const wsData = [headerRow, ...sheetData];

	// Create the worksheet
	const ws = XLSX.utils.aoa_to_sheet(wsData);

	// Set row height for the header
	ws["!rows"] = [{ hpx: 20 }]; // Header row height: 40 pixels

	// Optional: Set column widths
	const wscols = selectedColumnIds.map(() => ({ wpx: 110 })); // Column width: 150 pixels
	ws["!cols"] = wscols;

	// Append the worksheet to the workbook
	XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

	// Trigger the download
	XLSX.writeFile(wb, fileName);
};
